import styled from 'styled-components'
import Media from 'builder/styles/media'

export const Content = styled.div`
  width: 1120px;
  margin: 0 auto;

  height: 100%;
  display: flex;
  align-items: center;

  ${Media.Tablet`
    width: 100%;
    justify-content: center;
  `};
`

export const Row = styled.div`
  ${Media.AboveTablet`
    display: grid;
    grid-template-columns: 1fr 1fr;

    align-items: center;
    justify-content: space-between;
    margin: 0 32px;
  `};

  ${Media.Tablet`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    padding-bottom: 56px;
    height: 100%;

  `};

  ${Media.Phone`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    padding-bottom: 40px;
    height: 100%;
  `};
`

export const Left = styled.div`
  max-width: 448px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  ${Media.Tablet`
    max-width: 504px;
  `};

  ${Media.Phone`
    max-width: 335px;
    padding: 0 10px;
  `};
`

export const Right = styled.div`
  width: 544px;
  height: 560px;
  border: none;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  position: relative;
  display: none;

  ${Media.AboveTablet`
    width: 504px;
    height: auto;
    display: unset;
  `};
`

export const StyledVideo = styled.video`
  width: 100%;
  height: 504px;
  border-radius: 16px;
`

export const VideoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`
